export interface InboxViewport {
  top: number;
  atLatest: boolean;
  anchor: { reference: string; offset: number } | null;
}

// Anchor to the visible message, not the total height: a simultaneous live
// append must not be counted as height prepended above the reader.
export function captureInboxViewport(thread: HTMLElement): InboxViewport {
  const bounds = thread.getBoundingClientRect();
  const visible = [...thread.querySelectorAll<HTMLElement>("[data-message-ref]")]
    .find(message => {
      const box = message.getBoundingClientRect();
      return box.bottom > bounds.top && box.top < bounds.bottom;
    });
  return {
    top: thread.scrollTop,
    atLatest: thread.scrollHeight - thread.scrollTop - thread.clientHeight < 64,
    anchor: visible?.dataset.messageRef ? {
      reference: visible.dataset.messageRef,
      offset: visible.getBoundingClientRect().top - bounds.top
    } : null
  };
}

export function restoreInboxViewport(thread: HTMLElement, snapshot: InboxViewport | null, followLatest = false) {
  if (followLatest) { thread.scrollTop = thread.scrollHeight; return; }
  if (!snapshot) return;
  const anchor = snapshot.anchor && [...thread.querySelectorAll<HTMLElement>("[data-message-ref]")]
    .find(message => message.dataset.messageRef === snapshot.anchor!.reference);
  if (anchor && snapshot.anchor) {
    thread.scrollTop += anchor.getBoundingClientRect().top - thread.getBoundingClientRect().top - snapshot.anchor.offset;
  } else {
    thread.scrollTop = snapshot.top;
  }
}
